document.addEventListener('DOMContentLoaded', () => {
  // 1. Mobile Menu Toggle for Global Theme
  const menuToggle = document.querySelector('.menu-toggle');
  const mobileMenu = document.querySelector('.mobile-menu');
  const menuClose = document.querySelector('.mobile-menu-close');

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      mobileMenu.classList.remove('translate-x-full');
      mobileMenu.classList.add('translate-x-0');
    });
  }

  if (menuClose && mobileMenu) {
    menuClose.addEventListener('click', () => {
      mobileMenu.classList.remove('translate-x-0');
      mobileMenu.classList.add('translate-x-full');
    });
  }

  // 2. Mobile Menu Toggle for Artist Header
  const artistMenuToggle = document.querySelector('.artist-menu-toggle');
  const artistMobileDrawer = document.querySelector('.artist-mobile-drawer');
  const artistDrawerClose = document.querySelector('.artist-drawer-close');

  if (artistMenuToggle && artistMobileDrawer) {
    artistMenuToggle.addEventListener('click', () => {
      artistMobileDrawer.classList.remove('translate-x-full');
      artistMobileDrawer.classList.add('translate-x-0');
    });
  }

  if (artistDrawerClose && artistMobileDrawer) {
    artistDrawerClose.addEventListener('click', () => {
      artistMobileDrawer.classList.remove('translate-x-0');
      artistMobileDrawer.classList.add('translate-x-full');
    });
  }

  // 3. Audio Sample Player (Standard HTML5 Audio)
  let currentAudio = null;
  let currentPlayBtn = null;

  const playButtons = document.querySelectorAll('.track-play-btn');

  playButtons.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const audioUrl = btn.getAttribute('data-audio-url');
      if (!audioUrl) return;

      // If clicked the currently playing button, pause it
      if (currentPlayBtn === btn) {
        if (currentAudio) {
          if (currentAudio.paused) {
            currentAudio.play();
            btn.classList.add('playing');
            btn.querySelector('.play-icon').innerHTML = '&#10074;&#10074;'; // Pause icon
          } else {
            currentAudio.pause();
            btn.classList.remove('playing');
            btn.querySelector('.play-icon').innerHTML = '&#9658;'; // Play icon
          }
        }
        return;
      }

      // Stop previous audio
      if (currentAudio) {
        currentAudio.pause();
        if (currentPlayBtn) {
          currentPlayBtn.classList.remove('playing');
          currentPlayBtn.querySelector('.play-icon').innerHTML = '&#9658;';
        }
      }

      // Create and play new audio
      currentPlayBtn = btn;
      btn.classList.add('playing');
      btn.querySelector('.play-icon').innerHTML = '&#10074;&#10074;';

      currentAudio = new Audio(audioUrl);
      currentAudio.play().catch(err => {
        console.warn("Could not play audio sample automatically:", err);
      });

      // Reset button icon when audio ends
      currentAudio.addEventListener('ended', () => {
        btn.classList.remove('playing');
        btn.querySelector('.play-icon').innerHTML = '&#9658;';
        currentAudio = null;
        currentPlayBtn = null;
      });
    });
  });

  // Scroll effect on headers
  window.addEventListener('scroll', () => {
    const headers = document.querySelectorAll('.global-header, .artist-header');
    headers.forEach(header => {
      if (window.scrollY > 20) {
        header.classList.add('py-2', 'shadow-md');
        header.classList.remove('py-4');
      } else {
        header.classList.add('py-4');
        header.classList.remove('py-2', 'shadow-md');
      }
    });
  });
});
